import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/quotes/$id')({
  component: AdminQuoteIdLayout,
});

function AdminQuoteIdLayout() {
  return <Outlet />;
}
